import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { CreateSaleRequest, ReturnResult, ReturnSaleRequest } from '@/api/sales';
import type { Sale } from '@/api/types';

export function useCreateSale() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateSaleRequest) => api.post<Sale>('/api/sales', request),
    onSuccess: () => {
      // Stock moved and a customer's totals may have changed — everything
      // downstream of inventory needs a fresh read, not a patched cache.
      void queryClient.invalidateQueries({ queryKey: ['medicines'] });
      void queryClient.invalidateQueries({ queryKey: ['sales'] });
      void queryClient.invalidateQueries({ queryKey: ['customers'] });
      void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useReturnSale() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ saleId, request }: { saleId: string; request: ReturnSaleRequest }) =>
      api.post<ReturnResult>(`/api/sales/${saleId}/return`, request),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['medicines'] });
      void queryClient.invalidateQueries({ queryKey: ['sales'] });
      void queryClient.invalidateQueries({ queryKey: ['customers'] });
      void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}
